import React, {ReactNode} from 'react';
import joinClassNames from '../../../functions/joinClassNames';

export default function NavbarHeading(props: {text: ReactNode; className?: string}) {
  return <small className={joinClassNames('d-block', props.className)}>{props.text}</small>;
}
